import { render, staticRenderFns } from "./MdtDiseaseDetail.vue?vue&type=template&id=1660d293&scoped=true"
import script from "./MdtDiseaseDetail.vue?vue&type=script&lang=js"
export * from "./MdtDiseaseDetail.vue?vue&type=script&lang=js"
import style0 from "./MdtDiseaseDetail.vue?vue&type=style&index=0&id=1660d293&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1660d293",
  null
  
)

export default component.exports